// Сборка может лежать не в корне домена: новая версия лендинга живёт
// в подпапке /new, старая — в корне. Пути к файлам из public/ поэтому
// строим от PUBLIC_URL, который подставляется при сборке.
// Абсолютный путь вида "/video/poster.jpg" из подпапки уехал бы в корень,
// то есть в другую версию сайта, где этих файлов нет.
var BASE = process.env.PUBLIC_URL || "";

export default function asset(path) {
  return BASE + path;
}

// Какая версия лендинга собрана — уходит параметром визита в Метрику,
// чтобы конверсии двух версий можно было сравнить в одном отчёте.
export var SITE_VERSION = BASE ? "new" : "base";
